var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongDownC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94681 5.9469C7.94681 3.73776 9.73767 1.9469 11.9468 1.9469C14.1559 1.9469 15.9468 3.73776 15.9468 5.9469C15.9468 7.88714 14.5654 9.50473 12.7324 9.86977V15.8321H16.9824C17.2805 15.8321 17.5503 16.0086 17.6697 16.2818C17.7891 16.555 17.7353 16.8729 17.5328 17.0916L12.5328 22.4916C12.3908 22.6449 12.1914 22.7321 11.9824 22.7321C11.7735 22.7321 11.5741 22.6449 11.4321 22.4916L6.43212 17.0916C6.22958 16.8729 6.17582 16.5549 6.29517 16.2818C6.41453 16.0086 6.68433 15.8321 6.98244 15.8321H11.2324V9.88329C9.36415 9.54647 7.94681 7.9122 7.94681 5.9469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongDownC);
export default __webpack_public_path__ + "static/media/arrow-long-down-c.c3f8a4f6df947bb34529194f208b70be.svg";
export { ForwardRef as ReactComponent };